<h2 matDialogTitle class="m-b-0">{{headerName}}</h2>
<div mat-dialog-content id="create-new-employee-card" class=" m-t-10">
    <form class="form" role="form" [formGroup]="createNewEmployeeFormGroup" autocomplete="off">
        <!-- Company(Empresa) selection -->
        <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="menuSelectOption" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-label><strong>Empresa</strong></mat-label>
                    <!-- ORIGIN IS 0 FOR THE TREE VIEW THAT IS IN THE HEADER -->
                    <app-tree-view [origin]="1" (companyNode)="onChangeCompany($event)"></app-tree-view>
                </div>
                <mat-error class="m-t--5">
                    <span *ngIf="!isValidCompany" class="validation-span font-88">La empresa es obligatoria</span>
                </mat-error>
                <mat-error class="m-t--5">
                    <span *ngIf="!isCompanyEligible && showCompanyIneligibleMsg" class="validation-span font-88">Esta
                        empresa
                        no admite trabajadores</span>
                </mat-error>
            </div>
        </div>
        <!-- End of company selection -->

        <!-- Basic employee details -->
        <div *ngIf="this.isCompanyEligible"
            class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p" fxLayout="column">
            <div class="m-b-5">
                <label class="b-t-l"><strong>Datos personales</strong></label>
            </div>
            <div id="create-new-employee-card-wrapper" class="m-t-5" fxLayout="row wrap" fxLayout.xs="column"
                fxLayoutAlign="start baseline" fxFlex.gt-sm="100" fxLayoutGap="20px">
                <div class="widget">
                    <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                        <mat-label>Nombre</mat-label>
                        <input (blur)="CheckEmployee()" type="text" matInput formControlName="Name" maxlength="30" class="upper-case">
                    </mat-form-field>
                    <mat-error class="m-t--15"
                        *ngIf="createNewEmployeeFormGroup.get('Name').invalid || createNewEmployeeFormGroup.get('Name').hasError('whitespace')">
                        <span class="validation-span font-88">El nombre es obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                        <mat-label>Apellidos</mat-label>
                        <input (blur)="CheckEmployee()" type="text" matInput formControlName="Surname" maxlength="40" class="upper-case">
                    </mat-form-field>
                    <mat-error class="m-t--15" *ngIf="createNewEmployeeFormGroup.get('Surname').invalid">
                        <span class="validation-span font-88">El apellidos es obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget" *ngIf="isEmployeeRefVisible">
                    <mat-form-field class="example-full-width  bord-top-none" floatLabel="always">
                        <mat-label>Ref. Trabajador</mat-label>
                        <input (blur)="CheckEmployee()" matInput formControlName="EmployeeRef" class="upper-case" maxlength="20">
                    </mat-form-field>
                    <mat-error class="m-t--15"
                        *ngIf="(createNewEmployeeFormGroup.get('EmployeeRef').dirty || !createNewEmployeeFormGroup.get('EmployeeRef').touched ) && createNewEmployeeFormGroup.get('EmployeeRef').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('EmployeeRef').errors.maxLengthExceed"
                            class="validation-span">No puede exceder los 20 caracteres</span>
                    </mat-error>
                </div>
                <div class="widget" *ngIf="isEmployeeRefVisible">
                    <mat-form-field class="example-full-width  bord-top-none" floatLabel="always">
                        <mat-label>Puesto</mat-label>
                        <input matInput formControlName="Position" class="upper-case" maxlength="20">
                    </mat-form-field>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                        <mat-label>NIF</mat-label>
                        <input (blur)="CheckEmployee()" type="text" matInput formControlName="NIF" maxlength="10">
                    </mat-form-field>
                    <mat-error class="m-t--15" *ngIf="createNewEmployeeFormGroup.get('NIF').invalid">
                        <span class="validation-span font-88">El NIF es obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                        <mat-label>S.S.</mat-label>
                        <input matInput formControlName="SS" maxlength="15">
                    </mat-form-field>
                    <mat-error class="m-t--15"
                        *ngIf="(createNewEmployeeFormGroup.get('SS').dirty || !createNewEmployeeFormGroup.get('SS').touched ) && createNewEmployeeFormGroup.get('SS').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('SS').errors.maxLengthExceed"
                            class="validation-span">
                            No puede exceder los 15 caracteres
                        </span>
                    </mat-error>
                    <mat-error class="m-t--15"
                        *ngIf="(createNewEmployeeFormGroup.get('SS').dirty || !createNewEmployeeFormGroup.get('SS').touched ) && createNewEmployeeFormGroup.get('SS').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('SS').errors.pattern" class="validation-span">
                            Solo dígitos permitidos</span>
                    </mat-error>
                </div>
                <div class="widget" *ngIf="isHireDateVisible">
                    <mat-form-field class="example-full-width w-85 bord-top-none" floatLabel="always">
                        <mat-label>F. Antigüedad</mat-label>
                        <input matInput formControlName="HiringDate" [matDatepicker]="hireDate"
                            (click)="hireDate.open()">
                        <mat-datepicker-toggle matSuffix [for]="hireDate"></mat-datepicker-toggle>
                        <mat-datepicker #hireDate></mat-datepicker>
                    </mat-form-field>
                    <mat-error class="m-t--15" *ngIf="createNewEmployeeFormGroup.get('HiringDate').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('HiringDate').errors.required"
                            class="validation-span">
                            Obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget" *ngIf="isContractEndDateVisible">
                    <mat-form-field class="example-full-width w-85" floatLabel="always">
                        <mat-label>F. Fin Contrato</mat-label>
                        <input matInput formControlName="ContractEndDate" [matDatepicker]="contractEndDate"
                            (click)="contractEndDate.open()">
                        <mat-datepicker-toggle matSuffix [for]="contractEndDate"></mat-datepicker-toggle>
                        <mat-datepicker #contractEndDate></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width" floatLabel="always">
                        <mat-label>Sexo</mat-label>
                        <mat-select formControlName="Gender">
                            <mat-option value="HOMBRE">Hombre</mat-option>
                            <mat-option value="MUJER">Mujer</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error class="m-t--15" *ngIf="createNewEmployeeFormGroup.get('Gender').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('Gender').errors.required" class="validation-span">
                            Obligatorio</span>
                    </mat-error>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width w-85" floatLabel="always">
                        <mat-label>F. Nacimiento</mat-label>
                        <input matInput formControlName="BirthDate" [matDatepicker]="birthDate"
                            (dateChange)="onchangeBirthDate('change', $event)" (click)="birthDate.open()">
                        <mat-datepicker-toggle matSuffix [for]="birthDate"></mat-datepicker-toggle>
                        <mat-datepicker #birthDate></mat-datepicker>
                        <mat-error
                            *ngIf="(createNewEmployeeFormGroup.get('BirthDate').dirty || !createNewEmployeeFormGroup.get('BirthDate').touched ) && createNewEmployeeFormGroup.get('BirthDate').invalid">
                            <span *ngIf="createNewEmployeeFormGroup.get('BirthDate').errors.NoMoreThan80Years"
                                class="validation-span">
                                No puede tener más de 80 años.</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="widget">
                    <mat-form-field class="example-full-width" floatLabel="always">
                        <mat-label>Edad</mat-label>
                        <input matInput formControlName="Age">
                    </mat-form-field>
                </div>
                <div *ngIf="isJordanAllowed" class="widget">
                    <mat-form-field class="example-full-width" floatLabel="always">
                        <mat-label>% Jornada</mat-label>
                        <input type="number" matInput formControlName="WorkingHourPercent">
                    </mat-form-field>
                </div>

                <!-- <div class="widget p-l-5" *ngIf="createNewEmployeeFormGroup.get('Position')">

                    <mat-form-field *ngIf="!puestoControl.CustomInput" class="example-full-width" floatLabel="always">
                        <mat-label>{{puestoControl.label}}</mat-label>
                        <mat-select formControlName="Position">
                            <mat-option *ngFor="let option of puestoControl.Options" [value]="option.value">
                                {{option.text}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="puestoControl.CustomInput" class="example-full-width" floatLabel="always">
                        <mat-label>{{puestoControl.label}}</mat-label>
                        <input matInput formControlName="Position" [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let option of puestoControl.Options" [(value)]="option.value">
                                {{option.text}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-error class="m-t--15"
                        *ngIf="createNewEmployeeFormGroup.get('Position').touched && createNewEmployeeFormGroup.get('Position').invalid">
                        <span *ngIf="createNewEmployeeFormGroup.get('Position').errors.required"
                            class="validation-span">Obligatorio</span>
                    </mat-error>
                </div> -->

                <div class="widget checkbox m-t-15 p-l-5" fxFlex="100">
                    <mat-checkbox class="m-r-10 " formControlName="Urgent" id="chkbx">Urgente por puesto
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <!-- End of basic employee details-->

        <!--Employee attribute selection  -->
        <div *ngIf="this.isCompanyEligible" id="emp-attr-section"
            class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p ">
            <create-employee-attribute [createNewEmployeeFormGroup]="this.createNewEmployeeFormGroup"
                [empresaId]="this.selectedCompanyId" [empresaDetails]="this.empresaDetails">
            </create-employee-attribute>
        </div>
        <!-- End of employee attribute selection-->

        <!-- Employee contact details -->
        <div *ngIf="this.isCompanyEligible" id="emp-contact-detail"
            class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2">
            <div>
                <label class="b-t-l"><strong>Teléfonos</strong></label>
            </div>
            <div>
                <div fxFlex="100" fxFlex.gt-sm="25" class="m-r-10 example-full-width">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Telephone1" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(createNewEmployeeFormGroup.get('Telephone1').dirty || createNewEmployeeFormGroup.get('Telephone1').touched) && createNewEmployeeFormGroup.get('Telephone1').invalid">
                            <span *ngIf="createNewEmployeeFormGroup.get('Telephone1').errors"
                                class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="25" class="m-r-10 example-full-width">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Telephone2" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(createNewEmployeeFormGroup.get('Telephone2').dirty || createNewEmployeeFormGroup.get('Telephone2').touched) && createNewEmployeeFormGroup.get('Telephone2').invalid">
                            <span *ngIf="createNewEmployeeFormGroup.get('Telephone2').errors"
                                class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="25" class="m-r-10 example-full-width">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <input type="tel" matInput formControlName="Movil" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(createNewEmployeeFormGroup.get('Movil').dirty || createNewEmployeeFormGroup.get('Movil').touched) && createNewEmployeeFormGroup.get('Movil').invalid">
                            <span *ngIf="createNewEmployeeFormGroup.get('Movil').errors"
                                class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="25" class="m-r-10 example-full-width">
                    <div class="example-form">
                        <mat-form-field class="example-full-width bord-top-none" floatLabel="always">
                            <mat-label>Fac. por trab.</mat-label>
                            <input type="tel" matInput formControlName="Telephone4" minlength="9" maxlength="9">
                        </mat-form-field>
                        <mat-error class="m-t--5"
                            *ngIf="(createNewEmployeeFormGroup.get('Telephone4').dirty || createNewEmployeeFormGroup.get('Telephone4').touched) && createNewEmployeeFormGroup.get('Telephone4').invalid">
                            <span *ngIf="createNewEmployeeFormGroup.get('Telephone4').errors"
                                class="validation-span">Teléfono
                                inválido</span>
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of  employee contact details-->

        <!-- Employee address and other details -->
        <div *ngIf="this.isCompanyEligible" class="row p-0">
            <div id="emp-address-other" class="trabajador-panel">
                <div fxFlex="100" fxFlex.gt-sm="50" class="m-r-10">
                    <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p">
                        <label class="b-t-l"><strong>Dirección</strong></label>
                        <div class="example-form m-t-5">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <mat-label>Dirección</mat-label>
                                <input matInput formControlName="Direction1" class="upper-case" maxlength="100">
                            </mat-form-field>
                        </div>
                        <mat-form-field class="display-flex m-b-5 example-form" floatLabel="always">
                            <mat-label>Provincia</mat-label>
                            <mat-select formControlName="Province1">
                                <mat-option *ngFor="let province of provinceList" [value]="province.value"
                                    (click)="getProvinceCities(province.value)">
                                    {{province.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="example-form">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <mat-label>Población</mat-label>
                                <input type="text" class="upper-case" aria-label="Assignee" matInput
                                    formControlName="City1" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let city of directionService.cities" [value]="city.nombre">
                                        {{city.nombre}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div class="example-form">
                            <div class="widget position-relative">
                                <mat-form-field class="example-full-width" floatLabel="always">
                                    <mat-label>C.P.</mat-label>
                                    <input matInput formControlName="PostalCode1" maxlength="5">
                                </mat-form-field>
                                <mat-error
                                    *ngIf="(createNewEmployeeFormGroup.get('PostalCode1') && (createNewEmployeeFormGroup.get('PostalCode1').dirty || createNewEmployeeFormGroup.get('PostalCode1').touched)) && createNewEmployeeFormGroup.get('PostalCode1').invalid">
                                    <span
                                        *ngIf="createNewEmployeeFormGroup.get('PostalCode1').errors.NotAPostalCode || createNewEmployeeFormGroup.get('PostalCode1').errors.pattern"
                                        class="validation-span">
                                        C.P. inválido
                                    </span>
                                    <span
                                        *ngIf="createNewEmployeeFormGroup.get('PostalCode1').errors.noPostalCodeExists">
                                        El Código postal no es correcto
                                    </span>
                                </mat-error>
                                <div class="c-p-loader">
                                    <mat-icon *ngIf="direction1Validated" class="mat-icon material-icons f-s-19"
                                        color="accent">
                                        check
                                    </mat-icon>
                                    <mat-progress-spinner *ngIf="direction1Validating" [diameter]="20" color="accent"
                                        mode="indeterminate">
                                    </mat-progress-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div fxFlex="100" fxFlex.gt-sm="50">
                    <div class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2 m-0-p">
                        <label class="b-t-l"><strong>Dirección 2</strong></label>
                        <div class="example-form m-t-5">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <mat-label>Dirección</mat-label>
                                <input matInput formControlName="Direction2" class="upper-case" maxlength="100">
                            </mat-form-field>
                        </div>
                        <mat-form-field class="example-form display-flex m-b-5 " floatLabel="always">
                            <mat-label>Provincia</mat-label>
                            <mat-select formControlName="Province2">
                                <mat-option *ngFor="let province of provinceList" [value]="province.value"
                                    (click)="getProvince2Cities(province.value)">
                                    {{province.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="example-form">
                            <mat-form-field class="example-full-width" floatLabel="always">
                                <mat-label>Población</mat-label>
                                <input type="text" class="upper-case" aria-label="Assignee" matInput
                                    formControlName="City2" [matAutocomplete]="autoPobalicion">
                                <mat-autocomplete #autoPobalicion="matAutocomplete">
                                    <mat-option *ngFor="let city of directionService.cities2" [value]="city.nombre">
                                        {{city.nombre}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div class="example-form">
                            <div class="widget position-relative">
                                <mat-form-field class="example-full-width" floatLabel="always">
                                    <mat-label>C.P.</mat-label>
                                    <input matInput formControlName="PostalCode2" maxlength="5">
                                </mat-form-field>
                                <mat-error
                                    *ngIf="(createNewEmployeeFormGroup.get('PostalCode2') && (createNewEmployeeFormGroup.get('PostalCode2').dirty || createNewEmployeeFormGroup.get('PostalCode2').touched)) && createNewEmployeeFormGroup.get('PostalCode2').invalid">
                                    <span
                                        *ngIf="createNewEmployeeFormGroup.get('PostalCode2').errors.NotAPostalCode || createNewEmployeeFormGroup.get('PostalCode2').errors.pattern"
                                        class="validation-span">
                                        C.P. inválido
                                    </span>
                                    <span
                                        *ngIf="createNewEmployeeFormGroup.get('PostalCode2').errors.noPostalCodeExists">
                                        El Código postal no es correcto
                                    </span>
                                </mat-error>
                                <div class="c-p-loader">
                                    <mat-icon *ngIf="direction2Validated" class="mat-icon material-icons f-s-19"
                                        color="accent">
                                        check
                                    </mat-icon>
                                    <mat-progress-spinner *ngIf="direction2Validating" [diameter]="20" color="accent"
                                        mode="indeterminate">
                                    </mat-progress-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emp-direction" class="fuse-card auto-width m-b-5 mat-elevation-z2 p-0 acuation-card-border t-m-2">
                <mat-form-field class="example-full-width" class="width-50percent" floatLabel="always">
                    <textarea matInput lass="example-full-width" class="obs-direccion" formControlName="Observation"
                        placeholder="Obs. Dirección"></textarea>
                </mat-form-field>
            </div>
        </div>
        <!-- End of employee address and other details -->
    </form>
</div>
<div class="text-a-r p-t-10">
    <button [disabled]="!isValidCompany||!isCompanyEligible" class="m-r-15" mat-raised-button color="accent"
        (click)="onSubmit()">Guardar</button>
    <button mat-raised-button color="warn" (click)="cancel()">Cancelar</button>
</div>